import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-bg px-6 pb-10 pt-16 text-[13px] text-muted md:px-10">
      <div className="flex flex-wrap items-end justify-between gap-5">
        <div>
          <Link
            to="/"
            className="inline-block font-display text-[22px] font-semibold tracking-display text-ink no-underline transition hover:opacity-80"
          >
            takuna<span className="text-accent">.</span>stay
          </Link>
          <div className="mt-1.5">{t('footer.tagline')}</div>
        </div>
        <div className="md:text-right">{t('footer.note')}</div>
      </div>
      <div className="mt-9 border-t border-line pt-5 text-center">
        {t('footer.copyright', { year })}
      </div>
    </footer>
  );
}
